import modelmain from "./174_MainSeat.glb";
import ribs from "./174_Ribs.glb";
import logomain from "./174_MainLogo.glb";
import logohexa from "./174_HexaLogo.glb";
import logosuper from "./174_SuperLogo.glb";
// import raceNum from "./174number.glb";
import logoleft from "./174_OldLogoLeft.glb";
import logoright from "./174_OldLogoRight.glb";
import leftsuper from "./174_SideLogoLeftSuper.glb";
import rightsuper from "./174_SideLogoRightSuper.glb";
import number from "./174_Number.glb";
import badge from "./174_Badge.glb";
import { degsToRads } from "../../../utilities";

const modelParts = {
  main: modelmain,
  ribs: ribs,
  logoMain: logomain,
  logoSuper: logosuper,
  logoHexa: logohexa,
  logoLeft: logoleft,
  logoRight: logoright,
  number: number,
  badge: badge,
};

const leftLogoParts = {
  super: leftsuper,
};

const rightLogoParts = {
  super: rightsuper,
};

const numberCoords = {
  modelPosition: [0, 0.105, -0.346],
  modelRotation: [0, 0, 0],
  textPosition: [-0.03, -0.14, 0],
  textRotation: [Math.PI / -2.5, 0, 0],
  textScale: 0.35,
  decalSize: 0.08,
  letterSpacing: 0.03,
  aspectRatio: [2.93, 1],
};

const badgeCoords = {
  modelPosition: [-0.002, 0.1252, 0.296],
  modelRotation: [degsToRads(0), 0, degsToRads(0)],
  modelScale: 0.028,
  textNumberPosition: [-1.2, -4.03, -0.5],
  textNumberRotation: [degsToRads(273), degsToRads(-7), degsToRads(0)],
  textNumberScale: 0.68,
  textNamePosition: [-1.3, -4.01, 0.07],
  textNameRotation: [degsToRads(270), degsToRads(0), degsToRads(0)],
  textNameScale: 0.33,
};

const leftLogoCoords = {
  super: {
    position: [0.092, 0.004, 0.209],
    rotation: [Math.PI / 2, 0, -Math.PI / 2],
    scale: 1,
  },
};
const rightLogoCoords = {
  super: {
    position: [-0.092, 0, 0.209],
    rotation: [Math.PI / 2, 0, Math.PI / 2],
    scale: 1,
  },
};

export {
  modelParts,
  numberCoords,
  leftLogoCoords,
  leftLogoParts,
  rightLogoCoords,
  rightLogoParts,
  badgeCoords,
};
